import { render, staticRenderFns } from "./CustomGarmentsCustomizationModal.vue?vue&type=template&id=72e2258e&"
import script from "./CustomGarmentsCustomizationModal.vue?vue&type=script&lang=js&"
export * from "./CustomGarmentsCustomizationModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomGarmentsCustomizationModal.vue?vue&type=style&index=0&id=72e2258e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports